// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIngestionSpecResponseContent
 */
export interface GetIngestionSpecResponseContent {
    /**
     * 
     * @type {Date}
     * @memberof GetIngestionSpecResponseContent
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof GetIngestionSpecResponseContent
     */
    domain: string;
    /**
     * 
     * @type {Date}
     * @memberof GetIngestionSpecResponseContent
     */
    lastModifiedAt: Date;
    /**
     * Map structure representing JSON data
     * @type {{ [key: string]: any; }}
     * @memberof GetIngestionSpecResponseContent
     */
    spec: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof GetIngestionSpecResponseContent
     */
    specId: string;
    /**
     * 
     * @type {string}
     * @memberof GetIngestionSpecResponseContent
     */
    studyId: string;
}

/**
 * Check if a given object implements the GetIngestionSpecResponseContent interface.
 */
export function instanceOfGetIngestionSpecResponseContent(value: object): value is GetIngestionSpecResponseContent {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('spec' in value) || value['spec'] === undefined) return false;
    if (!('specId' in value) || value['specId'] === undefined) return false;
    if (!('studyId' in value) || value['studyId'] === undefined) return false;
    return true;
}

export function GetIngestionSpecResponseContentFromJSON(json: any): GetIngestionSpecResponseContent {
    return GetIngestionSpecResponseContentFromJSONTyped(json, false);
}

export function GetIngestionSpecResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIngestionSpecResponseContent {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'domain': json['domain'],
        'lastModifiedAt': (new Date(json['lastModifiedAt'])),
        'spec': json['spec'],
        'specId': json['specId'],
        'studyId': json['studyId'],
    };
}

export function GetIngestionSpecResponseContentToJSON(json: any): GetIngestionSpecResponseContent {
    return GetIngestionSpecResponseContentToJSONTyped(json, false);
}

export function GetIngestionSpecResponseContentToJSONTyped(value?: GetIngestionSpecResponseContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'domain': value['domain'],
        'lastModifiedAt': ((value['lastModifiedAt']).toISOString()),
        'spec': value['spec'],
        'specId': value['specId'],
        'studyId': value['studyId'],
    };
}
